import { required, decimal, integer } from '@vuelidate/validators'

export const CreateCalculationValidation = {
    shipmentType: { required },
    zone: { required },
    weight: { required, decimal },
    volumeWeight: { decimal },
    amountOfLoaders: { integer },
    hoursOfLoadersWork: { integer },
}

export const CreateInternationalCalculationValidation = {
    invoiceNumber: { required },
    companyId: { required },
    shipmentTypeId: { required },
    deliveryCharge: { required },
}
